import { Timestamp } from "firebase/firestore";
import { SearchHelper } from "../../utils/helpers";

export const activityToFirestore = (data, tenantData, authUser) => {
    const idTenant = typeof tenantData === 'string' ? tenantData : tenantData?.id;
    const tenantName = typeof tenantData === 'string' ? '' : (tenantData?.tenantName || tenantData?.name || '');
    if (!idTenant) throw new Error("ID do Tenant é obrigatório.");

    const cleanName = data.name?.trim() || "Nova Atividade";

    const payload = {
        idTenant,
        tenantName,
        name: cleanName,
        searchName: SearchHelper.normalize(cleanName),
        color: data.color,
        photoUrl: data.photoUrl,
        order: Number(data.order),
        xp: Number(data.xp),
        status: data.status,
        evaluationSystem: !!data.evaluationSystem,
        description: data.description,

        // Estrutura hierárquica
        objectives: (data.objectives || []).map(obj => ({
            id: obj.id || crypto.randomUUID(),
            name: obj.name?.trim() || "",
            order: Number(obj.order),
            xp: Number(obj.xp),
            topics: (obj.topics || []).map(topic => ({
                id: topic.id || crypto.randomUUID(),
                name: topic.name?.trim() || "",
                order: Number(topic.order),
                xp: Number(topic.xp),
                isFundamental: !!topic.isFundamental
            }))
        })),

        // Auditoria
        createdAt: data.id ? (data.createdAt || Timestamp.now()) : Timestamp.now(),
        updatedAt: Timestamp.now(),
        createdBy: (data.id && data.createdBy) ? data.createdBy : {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        },
        updatedBy: {
            uid: authUser?.uid || "system",
            name: authUser?.displayName || authUser?.fullName || authUser?.email || "Sistema"
        }
    };

    // Remove undefined
    Object.keys(payload).forEach(key => payload[key] === undefined && delete payload[key]);

    return payload;
};

/**
 * Mapeia os dados do Firestore para o React.
 */
export const activityFromFirestore = (snapshot) => {
    if (!snapshot.exists()) return null;
    const data = snapshot.data();

    return {
        id: snapshot.id,
        ...data,
        objectives: data.objectives || [],
        createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : data.createdAt,
        updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate() : data.updatedAt,
    };
};
